import Trustpilot from '~components/Trustpilot/Trustpilot';
import BBB from '~images/inline/BBB.inline.svg';

const ConsumerReviews = () => {
    return (
        <div className="flex justify-around items-center my-8 justify-items-center">
            <div>
                <Trustpilot size="mini" className="mx-auto" />
            </div>
            <div className="items-center">
                <a
                    href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="BBB Accredited Business, BBB rating A plus"
                >
                    <BBB width={100} height={48} />
                </a>
            </div>
        </div>
    );
};

export default ConsumerReviews;
